// frontend/src/services/stripeService.js
import axiosInstance from './axiosConfig';

/**
 * Get Stripe publishable key from backend
 */
export const getStripeConfig = async () => {
    const response = await axiosInstance.get('/stripe/config');
    return response.data;
};

/**
 * Create a PaymentIntent for a reservation
 * @param {number} reservationId - The reservation ID
 * @param {number} dayCount - Number of days for the reservation
 * @returns {Promise<{clientSecret: string, amount: number}>}
 */
export const createPaymentIntent = async (reservationId, dayCount) => {
    const response = await axiosInstance.post('/stripe/create-payment-intent', {
        reservationId,
        dayCount
    });
    return response.data;
};

/**
 * Confirm payment on the server after Stripe confirms on the frontend
 * @param {string} paymentIntentId - The Stripe PaymentIntent ID
 * @param {number} reservationId - The reservation ID
 * @returns {Promise<{success: boolean, message: string}>}
 */
export const confirmPayment = async (paymentIntentId, reservationId) => {
    const response = await axiosInstance.post('/stripe/confirm-payment', {
        paymentIntentId,
        reservationId
    });
    return response.data;
};
